import angular from 'angular';
import IMask, { InputMask, FactoryArg } from 'imask';
import { input } from '@b2b/types/core';

MaskOptionsDirective.$inject = [];

function MaskOptionsDirective() {
  
  class MaskOptionsController {
    static $inject = [];

    maskOptions = input.required<FactoryArg>({});
    maskValue = '';
    
    mask: InputMask<FactoryArg> | null = null;

    constructor() {}

    $onInit() {}

    maskElement(inputElement: HTMLInputElement) {
      if (this.maskOptions) {
        this.mask = IMask(inputElement, this.maskOptions);
      }
    }
  }

  function MaskOptionsLink(scope, element, attr, ctrl) {
    const inputElement: HTMLInputElement = element.get(0);

    const setMask = (event) => {
      ctrl.maskValue = (ctrl.mask) ? ctrl.mask.value : event.target.name;
    };

    if (inputElement && ctrl.maskOptions) {
      ctrl.maskElement(inputElement);
    }

    element.bind('blur', setMask);
    element.bind('change', setMask);
  }

  return {
    restrict: 'A',
    controllerAs: '$ctrl',
    controller: MaskOptionsController,
    bindToController: {
      ngModel: '=',
      maskOptions: '<',
      maskValue: '='
    },
    link: MaskOptionsLink,
  };
}

export const MaskOptionsDirectiveModule = angular
  .module('acme.common.directive.maskOptions', [])
  .directive('maskOptions', MaskOptionsDirective).name;
